import React from 'react';
import { useSelector } from 'react-redux';

import {
  InitializeState,
  InitializeStatus
} from 'common/modules/app/initialize';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';

import { AppState } from 'pages';
import { PlanListsHeder } from '../components/PlanListsHeder';
import { default as PlanLists } from './PlanLists';

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const initState = useSelector<AppState, InitializeState>(
    (state) => state.app.initialize
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  return {
    init: initState,
    glossary: Glossary.instance(glState)
  };
};

/**
 * プラン一覧画面全体のContainer Component
 */
export default function ContainerComponent() {
  const _props = { ...useStateProps() };
  const isCompleteInit = _props.init.status === InitializeStatus.FINISH;
  return (
    <section id="planListPage" data-test="planListPage">
      <PlanListsHeder glossary={_props.glossary} />
      {isCompleteInit ? <PlanLists /> : null}
    </section>
  );
}
